<template>
    <div class="page">
        <h1>This page is currently under maintenance. Please view my LinkedIn Profile.</h1>
        <p>Click the link below</p>
        <a href="https://www.linkedin.com/in/jamie-lee-kinnear-53980a23a/">My LinkedIn Profile link</a>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style scoped>
.page {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

a {
    font-size: 2rem;
}

p {
    text-decoration: underline;
}
</style>